import axios from "axios";
import React, { useEffect, useState } from "react";
import { BASE_URL, USER_URL } from "../../constant/api";
import { Link } from "react-router-dom";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import { ScaleLoader } from "react-spinners"; // Import ScaleLoader

function ListSubCategory() {
  const [products, setProducts] = useState([]);
  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isLoading, setIsLoading] = useState(true); // Add loading state
  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setIsLoading(true); // Set loading to true when starting fetch
        const response = await USER_URL.get(`/categories/admin/subcategories/`, {
          // headers: { Authorization: `JWT ${token}` },
        });
        console.log(response);
        
        setProducts(response.data?.data || []);
      } catch (error) {
        console.error("Error fetching products:", error.message || error);
      } finally {
        setIsLoading(false); // Set loading to false when done
      }
    };

    fetchProducts();
  }, [token]);

  const handleDelete = async () => {
    if (selectedProduct) {
      try {
        setIsLoading(true); // Show loading during delete
        await axios.delete(`${BASE_URL}/categories/admin/subcategories/${selectedProduct.id}/`);
        setProducts(products.filter((p) => p.id !== selectedProduct.id));
        setShowConfirm(false);
        setSelectedProduct(null);
      } catch (error) {
        console.error("Error deleting product:", error.message || error);
      } finally {
        setIsLoading(false); // Hide loading after delete
      }
    }
  };

  // Show loading spinner while data is being fetched
  if (isLoading && products.length === 0) {
    return (
      <div className="flex justify-center items-center h-96">
        <ScaleLoader color="#FFAE00" height={10} />
      </div>
    );
  }

  return (
    <div>
      {/* Header with Add New Category Button */}
      <div className="flex justify-end items-center m-5">
        <Link
          to="/admin/create/subcategory"
          className="bg-green-600 hover:bg-green-700 text-white font-medium py-2 px-6 rounded-lg shadow"
        >
          + Add sub Category
        </Link>
      </div>

      {/* Table Section */}
      <div className="overflow-auto mt-4">
        <table className="min-w-full text-center">
          <thead>
            <tr className="text-start">
              <th className="py-2 text-green-500 text-md font-bold">Item No</th>
              <th className="px-2 py-2 text-green-500 text-md font-bold">Category Name</th>
              <th className="px-2 py-2 text-green-500 text-md font-bold">Sub Category Name</th>
              
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan="5" className="py-10">
                  <div className="flex justify-center">
                    <ScaleLoader color="#FFAE00" height={30} width={4} radius={2} margin={2} />
                  </div>
                </td>
              </tr>
            ) : products.length > 0 ? (
              products.map((product, index) => (
                <tr key={product.id}>
                  <td className="py-3 px-3 text-sm">
                    <div className="rounded-lg border border-gray-300 py-2 text-gray-800">{index + 1}</div>
                  </td>
                  <td className="py-3 px-2 text-sm">
                    <div className="rounded-lg border border-gray-300 py-2 text-gray-800">{product.category || "Name"}</div>
                  </td>
                  <td className="py-3 px-2 text-sm">
                    <div className="rounded-lg border border-gray-300 py-2 text-gray-800">{product.name || "No Subcategory"}</div>
                  </td>
                  <td className="py-2 flex items-center justify-center">
                    <img
                      src={product.image || "https://via.placeholder.com/50"}
                      alt="Category"
                      className="w-16 h-16 object-cover rounded-lg border"
                    />
                  </td>
                  <td className="py-3 px-4 text-sm">
                    <div className="flex gap-5">
                      <Link
                        to={`/admin/edit/subcategory/${product.id}`}
                        className="flex-1 flex items-center justify-center px-2 py-2 text-xs sm:text-sm font-medium text-blue-600 hover:text-white border border-blue-600 rounded-lg shadow-md hover:bg-blue-700 hover:border-blue-700 transition text-center"
                      >
                        Edit
                      </Link>
                      <button
                        className="flex-1 flex items-center justify-center px-2 py-2 text-xs sm:text-sm font-medium text-red-600 hover:text-white border border-red-600 rounded-lg shadow-md hover:bg-red-700 hover:border-red-700 transition text-center"
                        onClick={() => {
                          setSelectedProduct(product);
                          setShowConfirm(true);
                        }}
                      >
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center py-4 text-gray-600">
                  No categories found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Delete Confirmation Modal */}
      {showConfirm && (
        <DeleteModal
          entityName="banner"
          title={selectedProduct?.title}
          onConfirm={handleDelete}
          onCancel={() => setShowConfirm(false)}
        />
      )}
    </div>
  );
}

export default ListSubCategory;
